import {
  SlideAction,
  SlideLayout,
  ViewMode
} from '@gripp/shared-ui';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { RoutineAllColumn } from './asset-routines-all-column';
import { AssetRoutinesHeader } from './asset-routines-header';
import { AssetRoutineRearrangeColumn } from './asset-routines-rearrange-column';

export const AssetRoutinesRearrange = () => {
  const { assetId } = useParams();
  const navigate = useNavigate();

  if (!assetId) {
    return null;
  }

  const leftColumn = (
    {
      title: 'asset.header.buttons.routines',
      mainComponent: (
        <RoutineAllColumn
          assetId={assetId}
        />
      ),
      showBackButton: true,
      headerComponent: (
        <AssetRoutinesHeader assetId={assetId} />
      ),
      backButtonTransition: SlideAction.PREV,
      onBackButtonPress: () => {
        navigate(`/assets/${assetId}/routines/all`);
      },
      disableScroll: true
    }
  );

  const rightColumn = (
    {
      title: 'topNav.edit',
      mainComponent: (<AssetRoutineRearrangeColumn assetId={assetId} />),
      showBackButton: true,
      backButtonTransition: SlideAction.PREV,
      onBackButtonPress: () => {
        navigate(`/assets/${assetId}/routines/all`);
      },
      disableScroll: true
    }
  );

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};
